import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "gfu-project-summary-action gfu-media gfu-media--middle",
  "data-qa": "project-summary-credits"
}
const _hoisted_2 = { class: "gfu-media__body" }
const _hoisted_3 = { class: "gfu-hd gfu-hd--h4 _ma-0" }
const _hoisted_4 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_icon, {
      name: "money-bill-wave",
      class: "gfu-project-summary-action__side _tc--accent"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString($options.formattedCreditsText), 1 /* TEXT */),
      _createElementVNode("a", {
        href: $options.backProjectUrl,
        class: "gfu-link gfu-link--accent"
      }, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryBoxSpendCreditsLink), 9 /* TEXT, PROPS */, _hoisted_4)
    ])
  ]))
}